// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagamentos-table td {
  padding-left: 10px;
  padding-right: 10px;
}

.title {
  font-size: 25px;
  display: block;
  width: 100%;
}

.hcentered {
  text-align: center;
}

.container-row {
  margin-left: 0px;
  margin-right: 0px;
  margin-bottom: 15px;
}

.mediaInput {
  margin: 20px;
}

.progressheader {
  display: inline;
}

.refreshicon {
  margin-bottom: 5px;
  margin-left: 10px;
}

h3 {
  text-align: left;
  font-weight: 500;
}

.box-dragndrop {
  display: none;
}

.box.has-advanced-upload {
  outline: 2px dashed #92b0b3;
  outline-offset: -10px;
  transition: outline-offset 0.15s ease-in-out, background-color 0.15s linear;
}

.box.has-advanced-upload .box-dragndrop {
  display: inline;
}

.box {
  font-size: 1.25rem;
  background-color: #f4f8fc;
  position: relative;
  padding: 50px 20px;
}

.box-icon {
  font-size: 4em;
  fill: #92b0b3;
  display: block;
  margin-bottom: 40px;
  text-align: center;
}

.box-button {
  text-align: center;
  display: block;
  margin: 20px auto 0;
}

.box-file {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  text-align: center;
}

.box-file-label-text {
  text-align: center;
  font-size: 18px;
}

.box-input {
  cursor: pointer;
}

.box-file-label {
  max-width: 80%;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
}
.box-file-label:hover {
  color: #e05048;
}

.cancel-button {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
}
.cancel-button:hover {
  color: #e05048;
}

.is-dragover {
  outline-offset: -20px;
  outline-color: #c8dadf;
  background-color: #cdcdcd;
}

.mat-column-meioPagamento {
  width: 50%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/fin/titulo/actions-modal/actions-modal.component.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,mBAAA;AAAJ;;AAIA;EACI,eAAA;EACA,cAAA;EACA,WAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,gBAAA;EACA,iBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,kBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,gBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,aAAA;AADJ;;AAIA;EACI,2BAAA;EACA,qBAAA;EAEA,2EAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,cAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,cAAA;EACA,mBAAA;AADJ;;AAIA;EACI,YAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,eAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;AADJ;AAGI;EACI,cAAA;AADR;;AAKA;EACI,gBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AAFJ;AAII;EACI,cAAA;AAFR;;AAMA;EACI,qBAAA;EACA,sBAAA;EACA,yBAAA;AAHJ;;AAMA;EACE,UAAA;AAHF","sourcesContent":["\r\n.pagamentos-table td{\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n}\r\n\r\n\r\n.title {\r\n    font-size: 25px;\r\n    display: block;\r\n    width: 100%;\r\n}\r\n\r\n.hcentered {\r\n    text-align: center;\r\n}\r\n\r\n.container-row {\r\n    margin-left: 0px;\r\n    margin-right: 0px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.mediaInput {\r\n    margin: 20px;\r\n}\r\n\r\n.progressheader {\r\n    display: inline;\r\n}\r\n\r\n.refreshicon {\r\n    margin-bottom: 5px;\r\n    margin-left: 10px;\r\n}\r\n\r\nh3 {\r\n    text-align: left;\r\n    font-weight: 500;\r\n}\r\n\r\n.box-dragndrop {\r\n    display: none;\r\n}\r\n\r\n.box.has-advanced-upload {\r\n    outline: 2px dashed #92b0b3;\r\n    outline-offset: -10px;\r\n    -webkit-transition: outline-offset .15s ease-in-out, background-color .15s linear;\r\n    transition: outline-offset .15s ease-in-out, background-color .15s linear;\r\n}\r\n\r\n.box.has-advanced-upload .box-dragndrop {\r\n    display: inline;\r\n}\r\n\r\n.box {\r\n    font-size: 1.25rem;\r\n    background-color: #f4f8fc;\r\n    position: relative;\r\n    padding: 50px 20px;\r\n}\r\n\r\n.box-icon {\r\n    font-size: 4em;\r\n    fill: #92b0b3;\r\n    display: block;\r\n    margin-bottom: 40px;\r\n    text-align: center;\r\n}\r\n\r\n.box-button {\r\n    text-align: center;\r\n    display: block;\r\n    margin: 20px auto 0;\r\n}\r\n\r\n.box-file {\r\n    width: 0.1px;\r\n    height: 0.1px;\r\n    opacity: 0;\r\n    overflow: hidden;\r\n    position: absolute;\r\n    z-index: -1;\r\n    text-align: center;\r\n}\r\n\r\n.box-file-label-text {\r\n    text-align: center;\r\n    font-size: 18px;\r\n}\r\n\r\n.box-input {\r\n    cursor: pointer;\r\n}\r\n\r\n.box-file-label {\r\n    max-width: 80%;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    overflow: hidden;\r\n\r\n    &:hover {\r\n        color: #e05048;\r\n    }\r\n}\r\n\r\n.cancel-button {\r\n    background: none;\r\n    color: inherit;\r\n    border: none;\r\n    padding: 0;\r\n    font: inherit;\r\n    cursor: pointer;\r\n    outline: inherit;\r\n\r\n    &:hover {\r\n        color: #e05048;\r\n    }\r\n}\r\n\r\n.is-dragover {\r\n    outline-offset: -20px;\r\n    outline-color: #c8dadf;\r\n    background-color: #cdcdcd;\r\n}\r\n\r\n.mat-column-meioPagamento{\r\n  width: 50%;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
